export const SITE_SECTION_EVENT = 'canvas-agent:site:section';
export const SITE_FILTER_EVENT = 'canvas-agent:site:filter';
export const SITE_FOCUS_EVENT = 'canvas-agent:site:focus';
export const SITE_CREATE_MODAL_EVENT = 'canvas-agent:site:create-modal';
export const SITE_EDIT_MODAL_EVENT = 'canvas-agent:site:edit-modal';
export const SITE_CONFIGURE_MODAL_EVENT = 'canvas-agent:site:configure-modal';
export const SITE_DELETE_MODAL_EVENT = 'canvas-agent:site:delete-modal';
export const SITE_CLONE_MODAL_EVENT = 'canvas-agent:site:clone-modal';
export const SITE_IMPORT_MODAL_EVENT = 'canvas-agent:site:import-modal';
export const SITE_RADIO_MODAL_EVENT = 'canvas-agent:site:radio-modal';
export const SITE_BULK_SECTION_EVENT = 'canvas-agent:site:bulk-section';
